module.exports = __webpack_public_path__ + "static/media/screwdriver.3fc20f6d.svg";